<template>
  <Head title="JurusanStats" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div>
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: 'JurusanStats', href: route('jurusanstats.index') },
          ]"
        />

        <!-- Header -->
        <div class="mb-6">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 class="text-2xl font-bold text-gray-900">JurusanStats</h1>
              <p class="mt-1 text-sm text-gray-600">
                Kelola konten section statistik jurusan di beranda
              </p>
            </div>
            <button
              @click="openModal"
              class="inline-flex items-center px-4 py-2.5 mt-4 sm:mt-0 text-sm font-semibold text-white bg-indigo-600 rounded-lg shadow-sm hover:bg-indigo-700"
            >
              <i class="mr-2 fa-solid fa-edit"></i>
              Edit Konten
            </button>
          </div>
        </div>

        <!-- Preview card -->
        <div class="overflow-hidden bg-white border border-gray-200 shadow-sm rounded-xl">
          <div
            class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 sm:px-6 sm:py-4"
          >
            <h2 class="flex items-center text-lg font-bold text-white">
              <i class="mr-2 fa-solid fa-chart-simple"></i>
              Data Saat Ini
            </h2>
          </div>
          <div class="p-4 sm:p-6">
            <dl class="divide-y divide-gray-100">
              <div class="grid grid-cols-1 gap-2 py-3 sm:grid-cols-3">
                <dt class="text-sm font-semibold text-gray-900">Judul</dt>
                <dd class="text-sm text-gray-700 sm:col-span-2">{{ d.title || "-" }}</dd>
              </div>
              <div class="grid grid-cols-1 gap-2 py-3 sm:grid-cols-3">
                <dt class="text-sm font-semibold text-gray-900">Deskripsi</dt>
                <dd class="text-sm text-gray-700 sm:col-span-2">{{ d.description || "-" }}</dd>
              </div>
              <div class="grid grid-cols-1 gap-2 py-3 sm:grid-cols-3">
                <dt class="text-sm font-semibold text-gray-900">URL Pendaftaran</dt>
                <dd class="text-sm text-gray-700 break-all sm:col-span-2">
                  <a
                    v-if="d.registration_url"
                    :href="d.registration_url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-indigo-600 hover:underline"
                    >{{ d.registration_url }}</a
                  >
                  <span v-else>-</span>
                </dd>
              </div>
              <div class="grid grid-cols-1 gap-2 py-3 sm:grid-cols-3">
                <dt class="text-sm font-semibold text-gray-900">Statistik Utama</dt>
                <dd class="text-sm text-gray-700 sm:col-span-2">
                  {{ d.mahasiswa_value || "-" }} {{ d.mahasiswa_label || "" }}
                </dd>
              </div>
              <div class="grid grid-cols-1 gap-2 py-3 sm:grid-cols-3">
                <dt class="text-sm font-semibold text-gray-900">Kotak Statistik</dt>
                <dd class="sm:col-span-2">
                  <div v-if="d.stats && d.stats.length" class="flex flex-wrap gap-2">
                    <span
                      v-for="(s, i) in d.stats"
                      :key="i"
                      class="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium text-indigo-700 rounded-full bg-indigo-50"
                    >
                      <strong>{{ s.value }}</strong> {{ s.label }}
                    </span>
                  </div>
                  <span v-else class="text-sm text-gray-400">-</span>
                </dd>
              </div>
              <div class="grid grid-cols-1 gap-2 py-3 sm:grid-cols-3">
                <dt class="text-sm font-semibold text-gray-900">Gambar</dt>
                <dd class="flex flex-wrap gap-3 sm:col-span-2">
                  <img
                    v-for="(img, i) in d.images || []"
                    :key="i"
                    :src="imgUrl(img)"
                    :alt="`Gambar ${i + 1}`"
                    class="object-cover w-32 h-20 border rounded-lg"
                  />
                  <span v-if="!(d.images && d.images.length)" class="text-sm text-gray-400">-</span>
                </dd>
              </div>
            </dl>
          </div>
        </div>

        <ModalJurusanStats
          v-model:isOpen="isModalOpen"
          title="Edit JurusanStats"
          :jurusanstat="jurusanstat"
        />
      </div>
    </template>
  </Container>
</template>

<script setup>
import { ref, computed, inject } from "vue";
import { Head } from "@inertiajs/vue3";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import ModalJurusanStats from "@/Components/ModalJurusanStats.vue";

const route = inject("route");

const props = defineProps({
  jurusanstat: { type: Object, required: true },
});

const d = computed(() => props.jurusanstat?.data || props.jurusanstat || {});

const isModalOpen = ref(false);
const openModal = () => (isModalOpen.value = true);

const imgUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//.test(path) || path.startsWith("/storage")) return path;
  if (path.startsWith("storage/")) return "/" + path;
  return "/storage/" + path;
};
</script>
